import React = require("react");
import { LimaIconProps } from "./DefLimaIconType";

export const LimaIconToolsTaskslist = ({
  size = 32, // or any default size of your choice
  color = "black", // or any color of your choice
  title = "", //title
}: LimaIconProps): JSX.Element => {
  return (
    // <svg
    //   xmlns="http://www.w3.org/2000/svg"
    //   viewBox="0 0 24 24"
    //   width={size} // added size here
    //   height={size} // added size here
    //   fill={color} // added color here
    //   aria-labelledby="title"
    // >
    //   <title id="title">{title}</title>
    //   <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" />
    //   <path d="M623.6 316.7C593.6 290.4 554 276 512 276s-81.6 14.5-111.6 40.7C369.2 344 352 380.7 352 420v7.6c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V420c0-44.1 43.1-80 96-80s96 35.9 96 80c0 31.1-22 59.6-56.1 72.7-21.2 8.1-39.2 22.3-52.1 40.9-13.1 19-19.9 41.8-19.9 64.9V620c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-22.7a48.3 48.3 0 0 1 30.9-44.8c59-22.7 97.1-74.7 97.1-132.5.1-39.3-17.1-76-48.3-103.3zM472 732a40 40 0 1 0 80 0 40 40 0 1 0-80 0z" />
    // </svg>

    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width={size} // added size here
      height={size} // added size here
      fill={color} // added color here
      aria-labelledby="title"
    >
      <title id="title">{title}</title>
      <g id="List_task" data-name="List task" transform="translate(-291.57 -84.384)">
        <rect
          id="Rectangle_24139"
          data-name="Rectangle 24139"
          width="32"
          height="32"
          transform="translate(291.57 84.384)"
          fill="none"
        />
        <g id="Group_13265" data-name="Group 13265" transform="translate(-1.654 -1.663)">
          <g id="Group_13245" data-name="Group 13245" transform="translate(297.72 92.028)">
            <path
              id="Path_8972"
              data-name="Path 8972"
              d="M3855,1268.2l1.443,1.443,3.012-3.012"
              transform="translate(-3855 -1266.628)"
              fill="none"
              stroke="#8e8e93"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.5"
            />
            <path
              id="Path_8979"
              data-name="Path 8979"
              d="M3855,1268.2l1.443,1.443,3.012-3.012"
              transform="translate(-3855 -1258.772)"
              fill="none"
              stroke="#8e8e93"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.5"
            />
            <path
              id="Path_8980"
              data-name="Path 8980"
              d="M3855,1268.2l1.443,1.443,3.012-3.012"
              transform="translate(-3855 -1250.522)"
              fill="none"
              stroke="#8e8e93"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.5"
            />
            <g id="Group_12391" data-name="Group 12391" transform="translate(7.501 1.111)">
              <path
                id="Path_8975"
                data-name="Path 8975"
                d="M3876.152,1277.889h12.2"
                transform="translate(-3876.152 -1277.889)"
                fill="none"
                stroke="#8e8e93"
                strokeLinecap="round"
                strokeWidth="1.5"
              />
            </g>
            <g id="Group_12396" data-name="Group 12396" transform="translate(7.501 9.362)">
              <path
                id="Path_8975-2"
                data-name="Path 8975"
                d="M3876.152,1277.889h8.341"
                transform="translate(-3876.152 -1277.889)"
                fill="none"
                stroke="#8e8e93"
                strokeLinecap="round"
                strokeWidth="1.5"
              />
            </g>
            <g id="Group_12393" data-name="Group 12393" transform="translate(7.501 17.306)">
              <path
                id="Path_8975-3"
                data-name="Path 8975"
                d="M3876.875,1277.948h12.175"
                transform="translate(-3876.875 -1277.948)"
                fill="none"
                stroke="#8e8e93"
                strokeLinecap="round"
                strokeWidth="1.5"
              />
            </g>
          </g>
          <g
            id="Rectangle_24135"
            data-name="Rectangle 24135"
            transform="translate(293.223 86.047)"
            fill="none"
            stroke="#8e8e93"
            strokeWidth="1.5"
          >
            <rect width="31" height="31" rx="3" stroke="none" />
            <rect x="0.75" y="0.75" width="29.5" height="29.5" rx="2.25" fill="none" />
          </g>
        </g>
      </g>
    </svg>
  );
};
